<template>
  <div class="content">
    <!--banner-->
    <div class="banner">
      <div class="banners">
        <div class="banner01">
<!--          <div class="login" v-if="!userinfo" style="height: 64px;">
            <div class="logins select" @click="login">立即登录</div>
            <div class="logins" style="margin-left: 20px">免费注册</div>
          </div>
          <div class="login" v-if="userinfo" style="height: 64px;">
            欢迎您，{{userinfo.phone}}
            <el-button style="margin-left: 20px;" type="text" size="mini">个人中心</el-button>
          </div> -->
          <div class="banner02">
          <div class="tiaobao">
            {{year}}年志愿模拟填报
            <div class="tianbaos" @click="tiaobao">
              <img src="../../assets/address.png" alt="" />
              {{province || "请选择"}}
            </div>
          </div>
          <div class="yugu">
            <span class="label">预估总分</span>
            <el-input placeholder="请输入分数" :disabled="beforeCF" v-model="score" type="number" class="input"></el-input>
          </div>
          <div class="yugu">
            <span class="label">选择类型</span>
             <el-select v-model="batch_type" @change="changeBatchType" placeholder="请选择" class="input">
                <el-option
                  v-for="item in batch_type_arr"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
          </div>
          <div class="yugu" v-if="batch_type=='普通类'">
            <span class="label">选择批次</span>
             <el-select v-model="batch" placeholder="请选择" class="input">
                <el-option
                  v-for="item in batch_arr"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
          </div>
          <div class="yugu subject-row"  v-if="batch_type=='普通类'">
            <span class="label">选择科目</span>
            <div class="subject-wrapper">
              <el-select v-model="group_d" :disabled="beforeCF" placeholder="请选择"  class="input subject-select" style="width: 258px !important; max-width: 258px !important; min-width: 258px !important;">
                 <el-option
                   v-for="item in group_arr"
                   :key="item"
                   :label="item"
                   :value="item">
                 </el-option>
               </el-select>
              <el-checkbox-group v-model="checkList" :max="2" class="checkbox-wrapper">
                <el-checkbox key="1" :disabled="beforeCF" :label="'生物'">生物</el-checkbox>
                <el-checkbox key="2" :disabled="beforeCF" :label="'化学'">化学</el-checkbox>
                <el-checkbox key="4" :disabled="beforeCF" :label="'政治'">政治</el-checkbox>
                <el-checkbox key="5" :disabled="beforeCF" :label="'地理'">地理</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <div class="yugu" v-if="batch_type=='高职单招'">
            <span class="label">选择类别</span>
             <el-select v-model="batch" placeholder="请选择" class="input">
                <el-option
                  v-for="item in batch_arr"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
          </div>
          
          <div class="success" @click="zhineng()" :disabled="loading">
            {{
              loading==false?"智能填报":"填报中..."
            }}
          </div>
        </div>

        </div>
      </div>
    </div>
    <!--banner-->

    <navVue />
    <zixunVue />
    <videoVue />

    <!--请选择你所在的高考省份-->
    <selectCity ref="provinceData" @provinceSu="provinceSu" />
  </div>
</template>

<script>
import selectCity from "@/components/selectCity.vue";
import navVue from "./components/nav.vue";
import zixunVue from "./components/zixun.vue"
import videoVue from "./components/video.vue"
import {mapGetters} from "vuex"
import { Volunteer_add } from "@/api/gw/index.js"
import { groupFind,batchGetgroup } from "@/api/gw/zonghe.js"
import { isYouxiao } from "@/api/gw/volunteer.js"
export default {
  components:{
    selectCity,navVue,zixunVue,videoVue
  },
  computed:{
    ...mapGetters(['isLogin',"userinfo"]),
  },
  watch:{
    batch(e){
      if(e){
        // this.group_d = ""
        console.log(e);
        this.$store.dispatch("set_batch",e);
        this.group_arr = []
        this.batchGetgroup(e);
      }
    }
  },
  data() {
    return {
      beforeCF:true,
      score:"",
      kemu:["化学","生物","政治","地理"],
      checkList:[],//所选科目
      province:"",//省份
      batch:"",//本科批
      batch_type:"普通类",
      batch_type_arr:["普通类"],//,"艺术类","体育类","高职单招"
      loading:false,
      year:new Date().getFullYear(),
      group_d:"",
      batch_arr:[],
      group_d_arr:[],
      share_pid:"",
      group_arr:[]
    };
  },
  mounted() {
    this.share_pid = this.$route.query.code || null;
    console.log("推广码",this.share_pid);
    if(this.share_pid!=null)this.$cookies.set("share_pid",this.share_pid);
    this.province = this.$cookies.get("province") || ""
    if(!this.province){
      this.$refs.provinceData.show();
    }
    this.groupFind();
    const token = localStorage.getItem("qichengUserToken")
    //自动填充
    if(token){
      console.log("login1")
      this.$store.dispatch("getUserInfo").then(res=>{
        if(res && res.zhiyuan){
          this.province = res.zhiyuan.province
					this.score = res.zhiyuan.score
					this.batch = res.zhiyuan.batch
          this.group_d = res.zhiyuan.group_d
					this.checkList = res.zhiyuan.subject.split(",")
        }
      });
    }
    isYouxiao({}).then(res=>{
      if(res.data.isT){   //当前时间在出分之后返回false  当在出分之后disabled应设为true
        this.beforeCF = false;
      }else{
        this.beforeCF = true;
      }
    })
  },
  methods: {
    changeBatchType(e){
      this.groupFind();
    },
    groupFind(){
      const examTypeRaw = localStorage.getItem('selectedExamType');
      const examType = ['1','2','3'].includes(String(examTypeRaw)) ? String(examTypeRaw) : '1';
      groupFind({ batch_type:this.batch_type, examType }).then(res=>{
        this.batch_arr = res.data.batch_arr
        // this.group_arr = res.data.group_d_arr
      })
    },
    batchGetgroup(e){
      const examTypeRaw = localStorage.getItem('selectedExamType');
      const examType = ['1','2','3'].includes(String(examTypeRaw)) ? String(examTypeRaw) : '1';
      batchGetgroup({ batch:e, examType }).then(res=>{
        this.group_arr = res.data
      })
    },
    //智能填报
    zhineng(){
      let that = this;
      if(!this.userinfo){
        this.$store.dispatch("set_isLogin",true)
        return;
      }
      if(!this.province){
        this.$message.error("请选择您的省份");
        return;
      }
      if(!this.score){
        this.$message.error("请输入您的分数");
        return;
      }
      let filteredSubjects = that.checkList.filter(subject => subject !== "物理" && subject !== "历史");
      that.checkList = filteredSubjects
      if(this.checkList.length==0 || this.checkList.length!=2){
        this.$message.error("请选择三项科目");
        return;
      }
      this.loading = true
      //处理数据
      let data = {
        province:this.province,
        score:this.score,
        batch:this.batch,
        subject:this.checkList,
        group_d:this.group_d
      };
      Volunteer_add(data).then(()=>{
        //  this.$message.success("填报成功");
         //此时应该跳转页面
         this.$router.push({
           path:"/Volunteer"
         })
      }).finally(()=>{
        this.loading = false
      })
    },
    tiaobao(){
      this.$refs.provinceData.show();
    },
    provinceSu(item){
      this.province = item
    },
  },
};
</script>

<style lang="scss">
// 全局样式：确保所有输入框和下拉框宽度一致（最高优先级）
.yugu > .el-input,
.yugu > .el-select,
.yugu > .input,
.yugu .el-input,
.yugu .el-select,
.yugu .input {
  width: 258px !important;
  max-width: 258px !important;
  min-width: 258px !important;
}
.yugu.subject-row .subject-wrapper .el-select,
.yugu.subject-row .subject-wrapper .el-select.input,
.yugu.subject-row .subject-wrapper .el-select.subject-select {
  width: 258px !important;
  max-width: 258px !important;
  min-width: 258px !important;
}
.yugu.subject-row .subject-wrapper .el-select .el-input {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 100% !important;
}
.yugu.subject-row .subject-wrapper .el-select .el-input .el-input__inner {
  width: 100% !important;
}
</style>

<style lang="scss" scoped>
  ::v-deep .el-radio__input.is-checked+.el-radio__label{
    color:#2AA38B!important;
  }
  ::v-deep .el-radio__input.is-checked .el-radio__inner{
    border-color: #2AA38B!important;
    background: #2AA38B!important;
  }
.success{
  width: 360px;
  height: 60px;
  background: #2AA38B;
  box-shadow: 0px 3px 16px 0px rgba(13,108,89,0.48);
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 24px;
  margin-top: 40px;
  margin-bottom: 30px;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    background: #238f7a;
    transform: translateY(-2px);
    box-shadow: 0px 5px 20px 0px rgba(13,108,89,0.6);
  }
}
::v-deep .el-checkbox{
  margin-right: 16px!important;
  margin-top: 8px;
  margin-bottom: 8px;
}
::v-deep .el-checkbox-group{
  line-height: 32px;
  margin-top: 8px;
}
::v-deep .el-checkbox__input.is-checked+.el-checkbox__label{
  color: #2AA38B!important;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: #2AA38B!important;
  border-color:#2AA38B!important;
}
.yugu{
  width: 100%;
  display: flex;
  align-items: center;
  color: #687382;
  font-size: 18px;
  margin-top: 24px;
  min-height: 48px;
  .label{
    flex: 0 0 90px;
    text-align: left;
    white-space: nowrap;
    font-weight: 500;
    color: #333;
    margin-right: 16px;
  }
  // 统一所有输入框和下拉框的宽度为 258px - 直接子元素
  ::v-deep > .el-input,
  ::v-deep > .el-select {
    width: 258px !important;
    max-width: 258px !important;
    min-width: 258px !important;
    margin-left: auto !important;
  }
  // 输入框样式 - 所有层级的 el-input
  ::v-deep .el-input {
    width: 258px !important;
    max-width: 258px !important;
    min-width: 258px !important;
    margin-left: auto !important;
    .el-input__inner {
      width: 100% !important;
      height: 48px !important;
      border: 1px solid #DBE1EA !important;
      border-radius: 6px !important;
      font-size: 16px !important;
      transition: all 0.3s ease;
      &:focus {
        border-color: #2AA38B !important;
        box-shadow: 0 0 0 2px rgba(42, 163, 139, 0.1) !important;
      }
    }
  }
  // 下拉框样式 - 所有层级的 el-select
  ::v-deep .el-select {
    width: 258px !important;
    max-width: 258px !important;
    min-width: 258px !important;
    margin-left: auto !important;
    display: inline-block !important;
    .el-input {
      width: 100% !important;
      max-width: 100% !important;
      .el-input__inner {
        width: 100% !important;
        height: 48px !important;
        border: 1px solid #DBE1EA !important;
        border-radius: 6px !important;
        font-size: 16px !important;
        transition: all 0.3s ease;
        &:focus {
          border-color: #2AA38B !important;
          box-shadow: 0 0 0 2px rgba(42, 163, 139, 0.1) !important;
        }
      }
    }
  }
  // .input 类样式
  ::v-deep .input {
    width: 258px !important;
    max-width: 258px !important;
    min-width: 258px !important;
    margin-left: auto !important;
  }
  // 选择科目特殊样式
  &.subject-row {
    align-items: flex-start;
    .label {
      margin-top: 12px;
    }
    .subject-wrapper {
      flex: 0 0 258px;
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-left: auto;
      width: 258px !important;
      max-width: 258px !important;
      min-width: 258px !important;
      // 强制选择科目下拉框宽度为 258px
      ::v-deep .el-select,
      ::v-deep .el-select.input,
      ::v-deep .el-select.subject-select {
        width: 258px !important;
        max-width: 258px !important;
        min-width: 258px !important;
        margin-left: 0 !important;
        display: inline-block !important;
        box-sizing: border-box !important;
        .el-input {
          width: 100% !important;
          max-width: 100% !important;
          min-width: 100% !important;
          .el-input__inner {
            width: 100% !important;
            height: 48px !important;
            border: 1px solid #DBE1EA !important;
            border-radius: 6px !important;
            font-size: 16px !important;
            transition: all 0.3s ease;
            box-sizing: border-box !important;
            &:focus {
              border-color: #2AA38B !important;
              box-shadow: 0 0 0 2px rgba(42, 163, 139, 0.1) !important;
            }
          }
        }
      }
      .checkbox-wrapper {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
      }
    }
  }
}
.login {
  width: 100%;
  height: 90px;
  border-bottom: 1px solid #eff2f7;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  .logins {
    width: 110px;
    height: 32px;
    border: 1px solid #dbdee3;
    border-radius: 19px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #687382;
    font-size: 16px;
  }
  .logins:hover,
  .select {
    color: #2aa38b;
    border: 1px solid #2aa38b;
  }
}
.content {
  width: 100%;
  .banner {
    width: 100%;
    height: 685px;
    background: #fff;
    background: url("../../assets/banner.png") no-repeat;
    background-size: 100%;
    z-index: 1;
    .banners {
      .banner01 {
        width: 420px;
        min-height: 500px;
        background: #fff;
        border-radius: 12px;
        position: absolute;
        top: 35px;
        right: 0px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
      }
      .banner02 {
        width: 360px;
        margin: 0 auto;
        padding: 0 20px;
        .tiaobao {
          width: 100%;
          display: flex;
          align-items: center;
          font-size: 22px;
          font-weight: 600;
          color: #333;
          padding-top: 32px;
          padding-bottom: 8px;
          white-space: nowrap;
          border-bottom: 1px solid #f0f0f0;
          margin-bottom: 8px;
          .tianbaos {
            display: flex;
            align-items: center;
            margin-left: auto;
            cursor: pointer;
            color: #2AA38B;
            font-weight: 400;
            font-size: 16px;
            transition: all 0.3s ease;
            &:hover {
              color: #238f7a;
            }
            img {
              width: 14px;
              height: 18px;
              margin-right: 6px;
            }
          }
        }
      }
      width: 1250px;
      height: 100%;
      margin: 0 auto;
      position: relative;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue